import AgenteEstrategico from '../components/ai/AgenteEstrategico'

export default function AgenteEstrategicoPage() {
  return <AgenteEstrategico />
}
